<form [formGroup]="formGroup">
  <py-dropdown
    [title]="'common.rowsPerPage_hint' | cxTranslate"
    [formControlName]="controlName"
    [options]="options || (basicOptionsMode ? basicOptions : standardOptions)"
  ></py-dropdown>
  <p>{{ 'common.rowsPerPage_hint' | cxTranslate }}</p>
</form>
